import type { IFilters } from '../shared/filters'

export enum InvoiceStatus {
  READY_TO_SEND = 'Ready to Send',
  SENT = 'Sent',
  PAYMENT_LATE = 'Payment Late',
  PAID = 'Paid',
}

export const InvoiceStatusOptions = Object.values(InvoiceStatus)

export enum InvoiceType {
  ANNUAL_PREMIUM = 'Annual Premium',
  MONTHLY_PREMIUM = 'Monthly Premium',
  REMITTANCE = 'Remittance',
  CLAIM_PAYMENT = 'Claim Payment',
  COMMISSION = 'Commission',
}

export interface IClaimInvoiceFilters extends IFilters {
  id?: number
  period?: string
  status?: string
  invoiced_to?: string
  customer_id?: number
  claim_number?: string
  type?: string
}

export interface IPremiumInvoiceFilters extends IFilters {
  id?: number
  start_date?: string
  end_date?: string
  status?: string
  customer_id?: number
  policy_group_number?: string
  type?: string
}

export interface ICreateClaimInvoiceForm {
  year: number
  month: number
  claim_ids: number[]
}

export interface ICreatePremiumInvoicePayload {
  issue_date: string
  due_date: string
  type: string
  status: InvoiceStatus
  policy_group_id?: number
  policies_quantity?: number
  policy_group_premium?: number
  policy_underwriting_fee?: number
  commission_percentage?: number
  invoice_file?: File
}

export interface IUpdateInvoiceForm {
  status?: InvoiceStatus
}

export interface IClaimInvoiceItem {
  claim_id: number
  policy_group_number: string
  claim_date_of_loss: string
  claim_number: string
  charge: string
  cost: string
  payable_from: string
  payable_to: string
}

export interface IClaimInvoice {
  id: number
  customer: string | null
  year: number
  month: number
  type: string
  amount: string
  status: InvoiceStatus
  invoiced_to: string
  items: Record<string, IClaimInvoiceItem[]>
  associated_claims: string[]
}

export interface IPremiumInvoiceFee {
  type: string
  amount: number
  payable_from: string
  payable_to: string
}

export interface IPremiumInvoice {
  id: number
  customer: string | null
  issue_date: string
  due_date: string
  type: string
  amount: string
  status: InvoiceStatus
  file_url: string | null
  invoiced_policies_quantity: number
  policy_group_premium: number
  policy_underwriting_fee: number
  commission_percentage: number
  fees: IPremiumInvoiceFee[]
}
